export const isClubleaDomain = () => {
  try {
    if (typeof window === "undefined" || !window.location) return false;
    const hostname = (window.location.hostname || "")
      .toLowerCase()
      .replace(/\.$/, "");
    if (!hostname) return false;
    return hostname !== "synkd.life" && !hostname.endsWith(".synkd.life");
  } catch (e) {
    return false;
  }
};
